export default {
  readMore: {
    id: 'product_page_condition_comparison_modal_link',
    defaultMessage: 'Discover Verified Refurbished',
  },
}
